let width = $(window).outerWidth();
let divWidth = $(".img-with-text").outerWidth();
let gap = (width - divWidth) / 2;

if (width > 992) {
  $(".img-with-text .right-bck").css("width", gap + "px");
  $(".img-with-text .right-bck").css("right", "-" + gap + "px");
}
